import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

export const queryOptions = ({ type = 'none', ...params }) => {

    const { t } = useTranslation();

    const query = useQuery({
        queryKey: ['get-options', type, params ],
        queryFn: async () => {
            const { data } = await axios.get(route('studio.internal.api.options.index', { type, ...params }));
            return data?.data || [];
        },
    });

    // The labels come from config in English; the picked language lives only in the browser.
    if (type === 'industry' || type === 'occasion') {
        return {
            ...query,
            data: query.data?.map((item) => ({
                ...item,
                label: t(`${type}.${item.value}`, item.label),
            })),
        };
    }

    return query;
}